/* eslint-disable react/jsx-props-no-multi-spaces */
import React, { useState, useEffect, useRef } from 'react';

import { Col } from 'react-bootstrap';
import {
  Card,
  CardBody,
} from '@/shared/components/Card';
import Chat from './ChatRedesigned';
import myContacts from './contacts';
import { getChat } from '../../../../utils/services/user.service';

const ChatCard = () => {

  return (

          <Chat
            contacts={myContacts}
            currentUser={{
                avatar: `${process.env.PUBLIC_URL}/img/ava.png`,
                name: 'Roman Johanson',
                userName: 'dragonKing',
              }}
          />

  );
};

export default ChatCard;

